import { useState } from "react";
import { toast } from "sonner";
import { CreditCard, Loader2 } from "lucide-react";
import { api, errMsg, eur } from "@/lib/api";
import { Button } from "@/components/ui/button";

const KLARNA_FEE = 6;

export const startCheckout = async (payload) => {
  const { data } = await api.post("/payments/checkout", { ...payload, origin_url: window.location.origin });
  window.location.href = data.checkout_url;
};

export const PayButtons = ({ lookupKey, praticaId, festivo = false, amount, email, compact = false, testid = "pay" }) => {
  const [busy, setBusy] = useState("");
  const go = async (klarna) => {
    setBusy(klarna ? "klarna" : "card");
    try { await startCheckout({ lookup_key: lookupKey, pratica_id: praticaId, festivo, klarna, customer_email: email || undefined }); }
    catch (e) { toast.error(errMsg(e)); setBusy(""); }
  };
  const klarnaTot = amount ? eur(amount * (1 + KLARNA_FEE / 100)) : null;
  return (
    <div className={`flex ${compact ? "flex-row flex-wrap" : "flex-col sm:flex-row"} gap-2`} data-testid={`${testid}-buttons`}>
      <Button onClick={() => go(false)} disabled={!!busy} data-testid={`${testid}-card`} className="rounded-full bg-[#B8860B] hover:bg-[#997316] text-white">
        {busy === "card" ? <Loader2 className="h-4 w-4 animate-spin" /> : <><CreditCard className="h-4 w-4 mr-2" />Paga con carta{amount ? ` · ${eur(amount)}` : ""}</>}
      </Button>
      <Button onClick={() => go(true)} disabled={!!busy} data-testid={`${testid}-klarna`} className="rounded-full bg-[#FFB3C7] hover:bg-[#ff9db8] text-[#0A0A0A] font-semibold">
        {busy === "klarna" ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Klarna · 3 rate{klarnaTot ? ` · ${klarnaTot}` : ""} <span className="ml-1 text-[11px] font-normal">(+{KLARNA_FEE}% commissioni)</span></>}
      </Button>
    </div>
  );
};
